import { IOktaMFAFactorLinkHints } from "./IOktaMFAFactorLinkHints";

export interface IOktaMFAFactorLink {
  href: string;
  hints: IOktaMFAFactorLinkHints;
}
